import { render, staticRenderFns } from "./AtencionesModalVerDetalle.vue?vue&type=template&id=7aaa3b10&"
import script from "./AtencionesModalVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./AtencionesModalVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./AtencionesModalVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports